import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

/** Manages global UI state such as the side-drawer toggle and plan-loading indicator. */
@Injectable({
  providedIn: 'root',
})
export class UiService {
  private toggleDrawerSubject = new Subject<void>();
  toggleDrawer$ = this.toggleDrawerSubject.asObservable();

  private planLoadingSubject = new BehaviorSubject<boolean>(false);
  planLoading$ = this.planLoadingSubject.asObservable();

  constructor() {}

  toggleDrawer() {
    this.toggleDrawerSubject.next();
  }

  setPlanLoading(loading: boolean) {
    this.planLoadingSubject.next(loading);
  }
}
